import { Info } from 'lucide-react'

interface RedirectBannerProps {
  campaniaOrigenNombre: string
}

export function RedirectBanner({ campaniaOrigenNombre }: RedirectBannerProps) {
  return (
    <div className="flex items-center gap-3 rounded-lg border border-blue-200 bg-blue-50 p-4">
      <Info className="h-5 w-5 text-blue-600 shrink-0" />
      <p className="text-sm text-blue-800">
        Este reporte muestra los datos de la campaña <strong>{campaniaOrigenNombre}</strong>.
        Fue redirigido desde una campaña relacionada.
      </p>
    </div>
  )
}
